import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { ITwoDigitDecimalInput } from '../interface';
import { NgModel } from '@angular/forms';
import { EDepositType } from '../enum';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';

@Component({
    selector: 'app-edit-deposit',
    templateUrl: './edit-deposit.component.html',
    styleUrls: ['./edit-deposit.component.scss'],
    standalone: false
})
export class EditDepositSharedComponent implements OnInit {
  private _initialDeposit: string = '$0.00';
  private _initialDepositPercentage: string = '0.00%';
  initialDepositNote: string = '';
  currentDeposit: string = '';
  depositNote: string = this.initialDepositNote;
  depositPercentage: string = '';
  isDepositSaved: boolean = false;
  @Output() editedDepositEmit: EventEmitter<any> = new EventEmitter<any>();
  @Input() editRightDeposit: boolean = false;
  @Input() depositType: number | null;
  @Input() unitRent: number = 0;
  @ViewChild('noteField') noteField: NgModel;
  @ViewChild('editDepositModal', { static: true }) editDepositModal: ModalDirective;
  eDepositType = EDepositType;
  modalConfig = {
    backdrop: 'static',
    keyboard: false
  };

  costValueDirectiveSetting: ITwoDigitDecimalInput = {
    Length: 5,
    IsCurrency: true,
    DefaultMinimum: true,
    MinimumValue: '0.00',
    MaximumValue: '99999.99',
    WholeValue: false,
  };

  @Input()
  set initialDeposit(value: string) {
    this._initialDeposit = `$${parseFloat(value).toFixed(2)}`;
    this.currentDeposit = this._initialDeposit;
  }

  get initialDeposit(): string {
    return this._initialDeposit;
  }

  @Input()
  set initialDepositPercentage(value: string) {
    this._initialDepositPercentage = `${parseFloat(value).toFixed(2)}%`;
    this.depositPercentage = this._initialDepositPercentage;
  }

  get initialDepositPercentage(): string {
    return this._initialDepositPercentage;
  }

  constructor( private prospectService: ProspectService, private modalWrapper: ModalWrapperService ) { }

  ngOnInit(): void { }

  isNoteRequired(): boolean {
    return this.currentDeposit != this._initialDeposit;
  }

  isSaveDisabled(): boolean {
    return (!this.isNoteRequired() || this.depositNote.trim() == '');
  }

  onCancel(): void {
      this.depositPercentage = this.initialDepositPercentage;
      this.currentDeposit = this.initialDeposit;
      this.depositNote = this.initialDepositNote;
      this.noteField?.control.markAsUntouched();
  }

  onSave() {
    const cleanedDeposit = parseFloat(this.currentDeposit.replace(/[$,]/g, ''));
    const cleanedDepositPercentage = parseFloat(this.depositPercentage.replace(/[%]/g, ''));
    const obj = {
      Deposit: cleanedDeposit,
      DepositPercentage: cleanedDepositPercentage,
      Notes: this.depositNote.trim()
    };
    this.initialDepositPercentage = this.depositPercentage;
    this.initialDeposit = cleanedDeposit.toFixed(2);
    this.initialDepositNote = this.depositNote.trim();
    this.editedDepositEmit.emit(obj);
  } 

  keyUpDeposit(val: string) {
    let value = parseFloat(val);
    if (isNaN(value)) {
      this.depositPercentage = '';
      this.currentDeposit = this.initialDeposit;
      return;
    }
    let deposit = value < 0 ? 0 : (value > 100 ? 100 : value);
    this.depositPercentage = deposit.toString();

    this.CalculatePercentage(this.unitRent, deposit);
  }

  CalculatePercentage(amount, percentage){
    this.prospectService.CalculatePercentage(amount, percentage).subscribe((res:any) =>{
      this.currentDeposit = `$${res.toFixed(2)}`;
    })
  }

  formatPercentage() {
    if (this.depositPercentage === '' || this.depositPercentage == null) {
      this.depositPercentage = null; 
    } else {
      this.depositPercentage = parseFloat(this.depositPercentage).toFixed(2) + '%';
    }
  }

  openModal() {
    this.modalWrapper.openDirective(this.editDepositModal);
  }

  closeModal() {
    this.editDepositModal.hide();
  }
}
